import _ from 'lodash';

import { ExternalCustomerLookupResult, LookupLevel } from 'models/external_customer_profile';
import { ExternalCustomerLookupStatusValue } from 'models/external_customer_lookup_status';
import { getLookupAnalyticsProps } from './lib/lookup_result';
import { trimAndRemoveEmptyQueryFields } from './lib/lookup_helpers';

export default class SearchExternalCustomers {
  constructor(context) {
    this.context = context;
  }

  run(query) {
    searchExternalCustomers(this.context, query);
  }
}

export function searchExternalCustomers(context, query) {
  let lookupStatus = context.stores.externalCustomerLookupStatus.get();
  if (lookupStatus && (lookupStatus.status !== ExternalCustomerLookupStatusValue.OK || lookupStatus.basicDisabled)) {
    return;
  }

  // Empty query acts just like clearing - if you perform a search and then get no results, and then you clear the search term you had,
  // you'd expect to see the suggestions again (at least I would)
  if (!_.compact(_.values(query)).length) {
    context.stores.externalCustomerSearchResults.resetPending();
    context.stores.externalCustomerSearchResults.remove();
    return;
  }

  context.analytics.track('Customer Profile Lookup - Searched', {
    customerId: context.stores.currentLocation.get().customerId,
    ...getLookupAnalyticsProps(context),
  });

  const { correlationId } = context.gateways.externalCustomerLookup.request({
    lookupLevel: LookupLevel.BASIC,
    query: trimAndRemoveEmptyQueryFields(query),
  });
  const pendingLookupResult = new ExternalCustomerLookupResult({ id: correlationId });
  context.stores.externalCustomerSearchResults.clearErrors();
  context.stores.externalCustomerSearchResults.setPending(pendingLookupResult);
}



// WEBPACK FOOTER //
// ./src/scripts/application/actions/external_customer_lookup/search_external_customers.js